<template>
    <div class="sec-cont">
        <Head :title="__('Chats')"/>
        <div class="container">
            <select-input class="pb-2 pr-6 w-full lg:w-1/6" :label="__('Select user')"
                          v-model="selectedUser"
                          @change="fetchAllRecentChats(selectedUser)"
            >
                <option value="">My Self</option>
                <option v-for="u in users" :key="u.id" :value="u.id">
                    {{ u.name }}
                </option>
            </select-input>
            <div id="app" class="app" style="width: 100%" :style="{ gridTemplateColumns: gridColumns }">
                <!-- LEFT SECTION -->
                <section id="main-left" class="main-left">
                    <!-- header -->
                    <div id="header-left" class="header-left" :class="{ 'hidden-content': selectedUser > 0 }">
                        <div class="header-left-icon-left">
                            <icon class="w-7 h-7 fill-gray-400 chat-icon" variant="light" name="chat"
                                  @click="openTab('recent-chat')" title="Recent chat"
                            />
                            <icon class="w-7 h-7 fill-gray-400 chat-icon" variant="secondary" name="contact"
                                  @click="openTab('employee-list')" title="Employee list"
                            />
                        </div>
                        <div class="header-left-icon-right">
                            <icon class="w-7 h-7 fill-gray-400 chat-icon" name="more" @click="toggleDropdown"/>

                            <div v-if="showDropdown" class="dropdown-menu">
                                <ul>
                                    <li @click="openGroupCreation">Create Group</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- chat list -->
                    <div id="chat-list" class="chat-list" v-if="isChatListVisible">
                        <div class="search-bar">
                            <input @keyup="search()" v-model="query" type="text"
                                   class="block w-auto p-2 ps-7 text-sm text-gray-900 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   :placeholder="placeholder" style="width: 100% !important; height: 40px"
                            >
                        </div>

                        <!-- 1st Tab - Recent chat -->
                        <div id="recent-chat" v-if="tab === 'recent-chat'">
                            <div v-if="recent_chats && this.query_recent_chats.length == 0">
                                <div
                                    class="recent-chat"
                                    v-for="(res, index) in recent_chats" :key="index"
                                    @click="startChat(res.chatroom.id, res.type)"
                                >
                                    <!-- photo -->
                                    <div class="profile friends-photo">

                                        <img :src="res.chatroom.photo_path"
                                             alt=""
                                        >
                                    </div>
                                    <div class="friends-credent">
                                        <!-- name -->
                                        <span class="friends-name">
                                             {{ res.chatroom.name }}
                                        </span>
                                        <!-- last message -->
                                        <span class="friends-message">{{ res.message }}</span>
                                    </div>
                                    <!-- notification badge -->
                                    <span class="badge notif-badge" v-show="res.unread > 0">{{
                                            res.unread
                                        }}</span>
                                </div>
                            </div>
                            <!-- More template content can go here -->
                        </div>

                        <div id="employee-list" v-if="tab === 'employee-list'">
                            <div
                                class="recent-chat"
                                v-for="(friend, index) in filteredusers"
                                :key="index"
                                @click="createSingle(friend.id)"
                            >
                                <div class="profile friends-photo">
                                    <img :src="`${friend.photo_path}`" alt="">
                                </div>
                                <div class="friends-credent">
                                    <span class="friends-name">{{ friend.name }}</span>
                                    <span class="friends-message">{{ friend.message }}</span>
                                </div>
                                <span class="badge notif-badge" v-show="friend.unread > 0">{{ friend.unread }}</span>
                            </div>
                            <!-- More template content can go here -->
                        </div>
                    </div>

                    <div id="group-user-list" class="chat-list" v-if="!isChatListVisible">
                        <div class="search-bar">
                            <input @keyup="searchUsers" v-model="searchQuery" type="text"
                                   class="block w-auto p-2 ps-7 text-sm text-gray-900 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   :placeholder="placeholder" style="width: 100% !important; height: 40px"
                            >
                        </div>

                        <div class="user-search">
                            <label for="groupName">Group Name:</label>
                            <input v-model="groupName" type="text" id="groupName" placeholder="Enter group name"
                                   class="form-control"
                            >

                            <ul>
                                <li v-for="(user, index) in filteredusers" :key="index">
                                    {{ user.name }}
                                    <button
                                        v-if="isUserSelected(user)"
                                        @click="removeUserById(user.id)"
                                        class="btn btn-danger btn-sm"
                                    >
                                        Remove
                                    </button>
                                    <button v-else @click="addUser(user)"
                                            class="btn btn-secondary btn-sm"
                                    >Add
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="btn-create-group">
                            <button @click="createGroup" class="btn btn-primary">Create Group</button>
                        </div>
                    </div>

                </section>

                <!-- RIGHT SECTION -->
                <section id="main-right" class="main-right">
                    <!-- header -->
                    <div id="header-right" class="header-right">
                        <!-- profile pict -->
                        <div id="header-img" class="profile header-img" v-if="chatroom_data">
                            <img :src="`${chatroom_data.user}`" alt="">
                        </div>

                        <!-- name -->
                        <h4 class="name friend-name my-0" v-if="chatroom_data">{{ chatroom_data.name }}</h4>

                        <div class="header-left-icon-right" v-if="currentGroupId"
                             :class="{ 'hidden-content': selectedUser > 0 }"
                        >
                            <icon class="w-7 h-7 fill-gray-400 chat-icon" name="more" @click="toggleMoreDropdown"/>
                            <div v-if="showMoreDropdown" class="dropdown-menu">
                                <ul>
                                    <li @click="toggleGrid">View Group Member</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- chat area -->
                    <div v-if="!chatroom_data" style="background-color: #efeae2">
                        <div class="jumbotron text-center d-flex align-items-center justify-center "
                             style="height: 100%;"
                        >
                            <h2 class="text-secondary d-table-cell h2">Start a new chat</h2>
                        </div>
                    </div>

                    <div v-if="chatroom_data" id="chat-area" class="chat-area">
                        <div v-for="(chat, index) in chatroom_data.messages" :key="index">
                            <!-- chat content -->
                            <div class="friends-chat" v-if="chat.sender.id != user.id">
                                <div class="profile friends-chat-photo">
                                    <img :src="`${chat.sender.photo}`" alt="">
                                </div>
                                <div class="friends-chat-content">
                                    <p class="friends-chat-name">{{ chat.sender.name }}</p>
                                    <p class="friends-chat-balloon text-break">{{ chat.message }}</p>
                                    <h5 class="chat-datetime">{{ formattedTime(chat.time) }}</h5>
                                </div>
                            </div>
                            <!-- YOUR CHAT TEMPLATE -->
                            <div class="your-chat" v-if="chat.sender.id == user.id">
                                <p class="your-chat-balloon text-break">{{ chat.message }}</p>
                                <p class="chat-datetime d-flex">
                                    {{ formattedTime(chat.time) }}
                                    <icon
                                        class="w-3 h-3 chat-icon ml-2"
                                        variant="light"
                                        :name="chat.read_at ? 'read' : 'unread'"
                                        :class="chat.read_at ? 'fill-blue-600' : 'fill-gray-400'"
                                    />


                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- typing area -->
                    <div id="typing-area" class="typing-area" :class="{ 'hidden-content': selectedUser > 0 }">
                        <!-- input form -->
                        <textarea id="type-area" class="type-area" @keydown="handleEnterKey"
                                  rows="1" v-model="message" v-if="chatroom_data" placeholder="Type something..."
                        ></textarea>
                        <!-- send btn -->
                        <icon class="w-7 h-7 fill-gray-400 chat-icon" name="send" @click="sendMessage()"
                              title="Send Message" v-if="chatroom_data"
                        />
                        <icon class="w-7 h-7 fill-gray-400 __attachment" name="attachment"
                              title="Send Message" v-if="chatroom_data"
                        />
                    </div>

                </section>

                <section class="main-left" v-if="isMembersVisible">
                    <div class="header-left">
                        <div class="header-left-icon-right">
                            <icon class="w-7 h-7 fill-gray-400 chat-icon" name="close" @click="toggleGrid"/>
                        </div>
                    </div>

                    <div class="chat-list">
                        <div class="search-bar">
                            <input @keyup="searchUsers" v-model="searchQuery" type="text"
                                   class="block w-auto p-2 ps-7 text-sm text-gray-900 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   :placeholder="placeholder" style="width: 100% !important; height: 40px"
                            >
                        </div>

                        <div class="user-search">
                            <ul>
                                <!--                                <li v-for="(user, index) in groupMembers" :key="index">
                                                                    {{ user.name }}
                                                                    <button
                                                                        v-if="isUserSelected(user)" @click="removeUserById(user.id)"
                                                                        class="btn btn-danger btn-sm">Remove</button>
                                                                    <button v-else @click="addUser(user)" class="btn btn-secondary btn-sm">
                                                                        Add
                                                                    </button>
                                                                </li>-->

                                <li v-for="user in filteredusers" :key="user.id">
                                    {{ user.name }}
                                    <button v-if="isGroupMember(user.id)"
                                            @click="removeGroupMember(currentGroupId, user.id)"
                                            class="btn btn-danger btn-sm"
                                    >Remove
                                    </button>
                                    <button v-else @click="addGroupMember(currentGroupId, user.id)"
                                            class="btn btn-secondary btn-sm"
                                    >Add
                                    </button>
                                </li>

                            </ul>
                        </div>
                        <div class="btn-create-group">
                            <button @click="deleteGroup(currentGroupId)" class="btn btn-primary">Delete Group</button>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'

export default {
    components: {
        SearchInput, Head, Icon, Link, SelectInput, Pagination,
    },
    layout: Layout,
    data() {
        return {
            selectedUser: '', // Initial value matches the default option value
            isChatListVisible: true,
            showDropdown: false,
            isMembersVisible: false,
            showMoreDropdown: false,
            isExpanded: false,
            gridColumns: '1fr 2fr',
            groupName: '',
            searchQuery: '',
            searchResults: [],
            selectedUsers: [],
            tab: 'recent-chat',
            message: '',
            query: null,
            search_result: null,
            placeholder: 'Search in recent chats...',
            friends: null,
            user: this.userprop,
            recent_chats: [],
            query_recent_chats: [],
            query_friend_list: [],
            notifications: [],
            chatroom_data: null,
            chatType: 'single', // Default chat type
            status: [],
            groupMembers: [],
            currentGroupId: null,
            currentConversationId: null,
        }
    },
    props: {
        title: String,
        auth: Object,
        project: Object,
        users: Array,
        userprop: Object,
    },
    computed: {
        filteredSearchResults() {
            console.log('function called filteredSearchResults')
            return this.searchResults.filter(user => {
                return !this.selectedUsers.some(selected => selected.id === user.id)
            })
        },
        filteredusers() {
            console.log('function called filteredusers')
            if (this.searchQuery) {
                return this.users.filter(user =>
                    user.name.toLowerCase().includes(this.searchQuery.toLowerCase()),
                )
            }
            console.log(this.recent_chats)
            return this.users
        },
    },
    methods: {
        isUserSelected(user) {
            console.log('function called isUserSelected')
            return this.selectedUsers.some(selected => selected.id === user.id)
        },
        removeUserById(userId) {
            console.log('function called removeUserById')
            this.selectedUsers = this.selectedUsers.filter(user => user.id !== userId)
        },
        openTab(tab) {
            console.log('function called openTab')
            this.query = null
            this.tab = tab
            this.search_result = null

            if (tab === 'recent-chat') {
                this.placeholder = 'Search in recent chats...'
                this.query_friend_list = []
                this.isChatListVisible = true
            } else if (tab === 'employee-list') {
                this.placeholder = 'Search in employee list...'
                this.query_recent_chats = []
                this.showDropdown = false
                this.isChatListVisible = true
            }
            console.log(this.recent_chats)
        },
        search() {
            console.log('function called search')
            if (this.tab === 'recent-chat') {
                this.query_recent_chats = this.recent_chats.filter(recent => {
                    return recent.friend.name.search(new RegExp(this.query, 'i')) + 1
                })
            } else if (this.tab === 'employee-list') {
                this.query_friend_list = this.users.filter(friend => {
                    return friend.name.search(new RegExp(this.query, 'i')) + 1
                })
            }
        },
        fetchAllRecentChats(id) {
            console.log('function called fetchAllRecentChats')
            axios.get(`/chats/${id}`).then((res) => {
                console.log('recent chat api')
                console.log(res.data)
                this.recent_chats = res.data
            }).catch(console.error)
            console.log(this.recent_chats)
        },
        startChat(id, type = 'single', name = '') {
            this.currentGroupId = null
            this.currentConversationId = id
            console.log('function called startChat')
            this.chatType = type

            console.log('startChat')
            console.log(this.recent_chats)


            // Leave the previous chat room if it exists
            if (this.chatroom_data) {
                Echo.leave(`chat.${id}`)
                this.chatroom_data = null
            }
            console.log(`/chat/${type}/${id}`)

            // Make the API request to start the chat (single or group)
            axios.post(`/chat/${type}/${id}`, {
                name: name,
                currentISOtime: new Date().toISOString(),
                user_id: this.selectedUser,
            })
                .then((res) => {
                    console.log('chat response ' + type)
                    console.log(res)
                    // Set up chat room data
                    if (!this.chatroom_data) {
                        this.chatroom_data = {} // Initialize as an empty object if null or undefined
                    }
                    console.log('chat response 1')
                    this.chatroom_data.chat = {conversation_id: res.data.conversation.id}
                    this.chatroom_data.participants = res.data.users
                    this.chatroom_data.messages = res.data.messages
                    this.chatroom_data.name = res.data.name
                    console.log('chat response 2')
                    // Update the recent chats list with the new message
                    if (this.selectedUser > 0) {
                        return
                    }
                    console.log('chat response 3')

                    if (this.chatType === 'group') {
                        this.currentGroupId = id
                    }
                    console.log('chat response 4')
                    const targetId = res.data.conversation?.id
                    console.log("inside else 5");
                    const existingIndex = this.recent_chats.findIndex((chat) => {
                        console.log('here is ')
                        console.log(chat)
                        if (chat.chat?.conversation_id !== undefined) {
                            return chat.chat.conversation_id === res.data.conversation?.id
                        }
                        return chat.chatroom.id === res.data.conversation?.id
                    })
                    console.log("inside else 4");
                    if (existingIndex !== -1) {
                        // Update the existing chat entry
                        const updatedChat = this.recent_chats[existingIndex]
                        updatedChat.message = res.data.content || ''
                        updatedChat.chat.created_at = new Date().toISOString()
                        updatedChat.unread = 0
                        this.recent_chats.splice(existingIndex, 1) // Remove the entry
                        this.recent_chats.unshift(updatedChat) // Move it to the top
                        console.log("markAsRead 1");
                        this.markAsRead(res.data.conversation.id)
                        if (type === 'group') {
                            this.viewGroupMembers(targetId)
                        }
                    } else {
                        // Add a new chat entry
                        console.log("inside else 1");
                        const newChat = {
                            message: '', type: type,
                            unread: 0,
                        }

                        this.currentGroupId = targetId
                        newChat.chatroom = res.data.conversation// Ensure `res.data.user` is correctly populated
                        newChat.chatroom.name = res.data.name

                        newChat.chat = {conversation_id: res.data.conversation?.id}
                        if (type === 'group') {
                            newChat.group = res.data.group
                            this.viewGroupMembers(targetId)
                        } else {
                            newChat.friend = res.data.users// Ensure `res.data.user` is correctly populate
                            this.tab = 'recent-chat'
                        }
                        console.log("inside else 2");
                        this.recent_chats.unshift(newChat)
                    }
                    console.log("inside else 3");
                    // Join the Echo channel for real-time updates
                    console.log("join chat "+ `chat.${res.data.conversation.id}`)
                    Echo.join(`chat.${res.data.conversation.id}`)
                        .here((users) => console.log(users)) // List users currently in the room
                        .joining((user) => console.log(user.name + ' joined.'))
                        .leaving((user) => console.log(user.name + ' left.'))
                        .listen('SendChat', (e) => {
                            // Push the new message to the chatroom
                            this.chatroom_data.messages.push({
                                message: e.payload.content,
                                sender: e.payload.user,
                                time: e.payload.created_at,
                            })
                            if (this.chatType === 'group') {
                                console.log("here 4")
                                this.addToFirstIndexInRecentChats(e.payload.group, e.payload.content, 'group')
                            } else {
                                console.log("here 3")
                                this.addToFirstIndexInRecentChats(e.payload.user, e.payload.content, 'single')
                            }
                        })
                })
                .catch(console.error)
        },
        viewGroupMembers(groupId) {
            axios.get(`/group/${groupId}/members`)
                .then((response) => {
                    this.groupMembers = response.data.members
                    console.log('here is member')
                    console.log(this.groupMembers)
                })
                .catch((error) => {
                    console.error('Error fetching group members:', error)
                })
        },
        isGroupMember(userId) {
            const groupMembers = Array.isArray(this.groupMembers)
                ? this.groupMembers
                : Array.from(this.groupMembers)
            const result = groupMembers.some(member => member.id === userId)
            console.log('here is result' + result + '  ' + userId)
            console.log('member')
            console.log(groupMembers)
            return result
        },
        addGroupMember(groupId, userId) {
            axios.post(`/group/${groupId}/add-member`, {user_id: userId})
                .then(() => {
                    const newMember = this.users.find(user => user.id === userId)

                    // Ensure `this.groupMembers` is converted to an array
                    const groupMembersArray = Array.isArray(this.groupMembers)
                        ? this.groupMembers
                        : Object.values(this.groupMembers)

                    this.groupMembers = [...groupMembersArray, newMember]
                })
                .catch((error) => {
                    console.error('Error adding group member:', error)
                })
        },
        removeGroupMember(groupId, userId) {
            if (confirm('Are you sure you want to remove this member?')) {
                axios.post(`/group/${groupId}/remove-member`, {user_id: userId})
                    .then((response) => {
                        this.groupMembers = this.groupMembers.filter(member => member.id !== userId)
                        alert(response.data.message)
                    })
                    .catch((error) => {
                        console.error('Error removing group member:', error)
                        alert('Failed to remove member')
                    })
            }
        },
        sendMessage() {
            console.log('function called sendMessage')
            if (!this.message.trim()) {
                alert('Message cannot be empty!')
                return
            }

            const payload = {
                message: this.message,
                conversation_id: this.chatroom_data.chat.conversation_id,
            }

            if (this.chatType === 'group') {
                payload.group = true
            }

            axios.post('/send', payload).then((res) => {
                console.log("send Message response")
                console.log(res)
            }).catch(console.error)

            this.message = ''
        },
        addUser(user) {
            // Add user to the selected users list if not already added
            if (!this.selectedUsers.find(selected => selected.id === user.id)) {
                this.selectedUsers.push(user)
            }
        },
        removeUser(index) {
            // Remove a user from the selected users list
            this.selectedUsers.splice(index, 1)
        },
        createGroup() {
            console.log('function called createGroup')
            if (this.groupName && this.selectedUsers.length > 0) {
                const groupData = {
                    name: this.groupName,
                    members: this.selectedUsers,
                }

                axios.post('/create-group', groupData).then((res) => {
                    this.startChat(res.data.conversation.id, 'group')
                }).catch(console.error)

                this.groupName = ''
                this.selectedUsers = []
                this.searchQuery = ''
                this.searchResults = []
                this.isChatListVisible = true
            } else {
                alert('Please enter a group name and add at least one user.')
            }
        },
        createSingle(id) {
            axios.get(`/create-single/${id}`).then((res) => {
                this.startChat(res.data.conversation.id, 'single')
            }).catch(console.error)

            this.groupName = ''
            this.selectedUsers = []
            this.searchQuery = ''
            this.searchResults = []
            this.isChatListVisible = true
        },
        async deleteGroup(groupId) {
            if (!confirm('Are you sure you want to delete this group?')) return

            try {
                await axios.delete(`/group/${groupId}`)
                alert('Group deleted successfully!')
                this.chatroom_data = null
                this.showDropdown = false
                // Optionally, remove the group from the frontend UI
                this.recent_chats = this.recent_chats.filter(chat => chat.chatroom.id !== groupId)
            } catch (error) {
                console.error('Error deleting group:', error)
                alert(error.response?.data?.error || 'Failed to delete the group.')
            }
        },
        addToFirstIndexInRecentChats(senderOrGroup, message, type) {
            if (type === 'group') {
                // Update the recent chat for group
                this.recent_chats.map(recent => {
                    if (recent.chat.conversation_id === senderOrGroup) { // Check if `group` exists
                        recent.chat.message = message
                        recent.chat.created_at = new Date().toISOString()
                        recent.chat.updated_at = new Date().toISOString()
                    }
                })

                // Move the group to the top of recent chats
                const recentlyOpenedGroup = this.recent_chats.filter(recent => {
                    return recent.chat.conversation_id === senderOrGroup // Check if `group` exists
                })
                this.recent_chats = this.recent_chats.filter(recent => {
                    console.log('inside recent debug')
                    console.log(recent.chat.conversation_id + ' ' + senderOrGroup)
                    return recent.chat.conversation_id !== senderOrGroup // Check if `group` exists
                })
                if (recentlyOpenedGroup.length > 0) {
                    this.recent_chats.unshift(recentlyOpenedGroup[0])
                }
            } else {
                // Update the recent chat for single chat
                this.recent_chats.map(recent => {
                    if (recent.friend && recent.friend.id === senderOrGroup.id) { // Check if `friend` exists
                        recent.chat.message = message
                        recent.chat.created_at = new Date().toISOString()
                        recent.chat.updated_at = new Date().toISOString()
                    }
                })

                // Move the single chat to the top of recent chats
                const recentlyOpenedUser = this.recent_chats.filter(recentChat => {
                    return recentChat.friend && recentChat.friend.id === senderOrGroup.id // Check if `friend` exists
                })
                this.recent_chats = this.recent_chats.filter(recentChat => {
                    return !recentChat.friend || recentChat.friend.id !== senderOrGroup.id // Check if `friend` exists
                })
                if (recentlyOpenedUser.length > 0) {
                    this.recent_chats.unshift(recentlyOpenedUser[0])
                }
            }
            console.log('after recent_chats')
            console.log(this.recent_chats)
        },
        formattedTime(currentISOtime) {
            const timestamp = new Date(currentISOtime)
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thru', 'Fri', 'Sat']
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            const addZeroOffset = timeObject => {
                if (timeObject < 10) return '0' + timeObject
                return timeObject
            }
            return `${days[timestamp.getDay()]}, ${months[timestamp.getMonth()]} ${addZeroOffset(timestamp.getDate())} | ${addZeroOffset(timestamp.getHours())}:${addZeroOffset(timestamp.getMinutes())}`
        },
        toggleDropdown() {
            // Toggles the dropdown visibility
            this.showDropdown = !this.showDropdown
        },
        toggleMoreDropdown() {
            // Toggles the dropdown visibility
            this.showMoreDropdown = !this.showMoreDropdown
        },
        openGroupCreation() {
            this.isChatListVisible = false
            this.toggleDropdown()
        },
        toggleGrid() {
            // Toggle between two and three columns
            this.isExpanded = !this.isExpanded
            this.gridColumns = this.isExpanded ? '1fr 2fr 1fr' : '1fr 2fr'
            this.showMoreDropdown = false
            this.isMembersVisible = !this.isMembersVisible
        },
        runThisUserEchoListener() {
            console.log("user channel is " + `user.${this.user.id}`)
            Echo.private(`user.${this.user.id}`)
                .listen('ReceiveMessage', (e) => {
                    // Handle single chat message
                    const isExist = this.recent_chats.filter(recent => {
                        return recent.chat.conversation_id === e.payload.conversation_id
                    })
                    console.log('exist here')
                    console.log(this.recent_chats)
                    console.log(this.currentConversationId + '  ' + e.payload.conversation_id)

                    let userOrConversationId = 0
                    if (!isExist.length) {
                        userOrConversationId = e.payload.conversation_id

                        // If the user does not exist in recent chats, add them
                        this.recent_chats.unshift({
                            chat: {message: e.payload.content, conversation_id: e.payload.conversation_id},
                            chatroom: {
                                name: e.payload.user.name,
                                id: userOrConversationId,
                                pivot: {conversation_id: e.payload.conversation_id},
                            },
                            name: e.payload.conversation.name,
                            message: e.payload.content,
                            type: e.payload.conversation.type,
                            friend: e.payload.user,
                            unread: 1,
                        })
                    } else {
                        // If the user already exists in recent chats, put them on top
                        if (this.chatType === 'group') {
                            console.log('here 1')
                            this.addToFirstIndexInRecentChats(e.payload.conversation_id, e.payload.content, 'group')
                        } else {
                            console.log('here 2')
                            this.addToFirstIndexInRecentChats(e.payload.user, e.payload.content, 'single')
                        }
                        // Increment unread message count for this user
                        this.incrementUnreadMessages(e.payload)
                    }
                })
                .listen('SendNotification', (e) => {
                    if (e.payload.notification.type === 'friend-request') {
                        this.notifications.push({
                            notif: e.payload.notification,
                            sender: e.payload.sender,
                        })
                    }

                    if (e.payload.notification.type === 'friend-request-accepted') {
                        this.notifications.push({
                            notif: e.payload.notification,
                            sender: e.payload.sender,
                        })
                    }

                    console.log('This is from sendnotification event.')
                    console.log(e)  // Log the event data to check its structure
                })
            console.log('end ReciveMessage')
        },
        incrementUnreadMessages(payload) {
            /**
             * increment the number of unread messages this user has.
             * The number will be shown on the badge in the recent chat list.
             */

            if (this.currentConversationId === payload.conversation_id) {
                const existingIndex = this.recent_chats.findIndex((chat) => {
                    return chat.chat.conversation_id === payload.conversation_id
                })
                if (existingIndex !== -1) {
                    this.recent_chats[existingIndex].unread = 0
                }
                console.log("markAsRead 2");
                this.markAsRead(payload.conversation_id)
            } else {
                this.recent_chats.map(recent => {
                    if (recent.chat.conversation_id === payload.conversation_id) recent.unread++
                    if (recent.chat.conversation_id === payload.conversation_id) recent.message = payload.content
                })
            }
        },
        markAsRead(conversationId) {
            axios.post('/mark-as-read', {conversation_id: conversationId})
                .then(response => {
                    console.log(response.data.message) // Handle success
                })
                .catch(error => {
                    console.error(error) // Handle error
                })
        },
    },
    mounted() {
        this.fetchAllRecentChats(0)
        this.runThisUserEchoListener()
    },
    updated() {
        if (this.chatroom_data) {
            const chatArea = document.getElementById('chat-area')
            if (chatArea) chatArea.scrollTop = chatArea.scrollHeight
        }
    },
}
</script>
